import { TTrackEventData } from '@src/tracking/constant';

export const DELIVERY_DASHBOARD_PAGE_TRACKING_EVENTS = {
  COURIER_LIST_VIEW: {
    component_name: 'manage delivery - couriers',
    component_type: 'list',
    list_action: 'view',
    list_countsTotal: '',
    country: '',
    language: '',
    event: 'list_view',
    $registryName: 'COURIER_LIST_VIEW',
  },
  ORDER_LIST_VIEW: {
    component_name: 'manage delivery - orders',
    component_type: 'list',
    list_action: 'view',
    list_countsTotal: '',
    country: '',
    language: '',
    event: 'list_view',
    $registryName: 'ORDER_LIST_VIEW',
  },
  FILTERED_ORDER_LIST_VIEW: {
    component_name: 'manage delivery - orders',
    component_type: 'list',
    list_action: '',
    list_countsTotal: '',
    country: '',
    language: '',
    event: 'list_view',
    $registryName: 'FILTERED_ORDER_LIST_VIEW',
  },
  COURIER_DETAIL_VIEW: {
    component_name: 'manage delivery - couriers',
    component_type: 'courier card',
    component_source: 'control panel',
    courierDetail: '',
    country: '',
    language: '',
    event: 'courierCard_view',
    $registryName: 'COURIER_DETAIL_VIEW',
  },
  COURIER_DETAIL_VIEW_VIA_MAP: {
    component_name: 'manage delivery - couriers',
    component_type: 'courier card',
    component_source: 'map icon',
    courierDetail: '',
    country: '',
    language: '',
    event: 'courierCard_view',
    $registryName: 'COURIER_DETAIL_VIEW_VIA_MAP',
  },
  ORDER_DETAIL_VIEW: {
    component_name: 'manage delivery - orders',
    component_type: 'order',
    component_source: 'control panel',
    order_action: 'single order detail open',
    order_hashed: '',
    order_id: '',
    country: '',
    language: '',
    event: 'order_detail',
    $registryName: 'ORDER_DETAIL_VIEW',
  },
  ORDER_DETAIL_VIEW_VIA_MAP: {
    component_name: 'manage delivery - orders',
    component_type: 'order',
    component_source: 'map icon',
    order_action: 'single order detail open',
    order_hashed: '',
    order_id: '',
    country: '',
    language: '',
    event: 'order_detail',
    $registryName: 'ORDER_DETAIL_VIEW_VIA_MAP',
  },
  MAP_INTERACTION: {
    component_name: 're-centre',
    component_type: 'map icon',
    map_action: 'click',
    country: '',
    lanugage: '',
    event: 'map_interaction',
    $registryName: 'MAP_INTERACTION',
  },
};

export type TDashboardCourierListViewData = TTrackEventData<{
  list_action: string;
  list_countsTotal: string;
}>;

export type TDashboardOrderListViewData = TTrackEventData<{
  list_action: string;
  list_countsTotal: string;
}>;

export type TDashboardOrderListFilteredViewData = TTrackEventData<{
  list_action: string;
  list_countsTotal: string;
}>;

export type TDashboardCourierDetailViewData = TTrackEventData<{
  component_source: string;
  courierDetail: string;
}>;

export type TDashboardOrderDetailViewData = TTrackEventData<{
  component_source: string;
  order_action: string;
  order_hashed: string;
  order_id: string;
}>;

export type TDashboardMapInteractionData = TTrackEventData<{
  map_action: string;
}>;
